import React from 'react';
import { cn } from '../../../components/ui/_cn';

// The two Finance buttons (spec 2026-09-21 §3.3). TWButton carries slate
// classes and its own dark: twins, which is exactly what the token set
// exists to replace, so Finance cards use this instead.
const VARIANTS = {
  outlined: 'bg-fin-surface border border-fin-border-2 text-fin-ink hover:bg-fin-recess',
  primary: 'bg-fin-blue text-white shadow-[0_1px_2px_rgba(47,107,237,0.3)] hover:bg-fin-blue-hover',
};

const SIZES = {
  md: { outlined: 'text-[13.5px] px-3.5 py-2.5', primary: 'text-[13.5px] px-4 py-2.5' },
  sm: { outlined: 'text-[12.5px] px-3 py-1.5', primary: 'text-[12.5px] px-3.5 py-1.5' },
};

// Disabled is its own look, chosen instead of the variant's — never
// appended over it, which would leave two border/text utilities competing
// by stylesheet order.
const DISABLED = 'bg-fin-surface border border-fin-border text-fin-chrome cursor-default';

const FinButton = ({ variant = 'outlined', size = 'md', disabled = false, children, ...rest }) => (
  <button
    {...rest}
    type="button"
    disabled={disabled}
    className={cn(
      'inline-flex shrink-0 items-center justify-center whitespace-nowrap rounded-lg font-semibold',
      disabled ? DISABLED : VARIANTS[variant] || VARIANTS.outlined,
      (SIZES[size] || SIZES.md)[variant] || SIZES.md.outlined,
    )}
  >
    {children}
  </button>
);

export default FinButton;
